import Button from 'components/partials/button/button';

import { CLIENT_SUCCESS_MAILTO } from 'constants/contacts';

import Icons from 'assets/icons';

import {
  EXTEND_WITH_PRODUCT_LABEL,
  EXTEND_WITH_UPSELL_DESCRIPTION,
} from 'containers/user/critical-elements-monitoring/monitoring-constants';
import type { ExtendWithOption } from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

export interface ExtensionUpsellTileProps {
  title: string;
  type: ExtendWithOption;
  contactTestId: string;
  testId?: string;
}

const ExtensionUpsellTile = ({
  title,
  type,
  contactTestId,
  testId,
}: ExtensionUpsellTileProps) => {
  const handleContactClick = (): void => {
    window.location.href = CLIENT_SUCCESS_MAILTO;
  };

  return (
    <div
      className="flex w-full flex-col overflow-hidden rounded-lg border border-gray-200"
      data-testid={testId}
    >
      <div className="flex items-center justify-between gap-2 bg-gray-200 px-3 py-2">
        <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
        <Icons.Lock className="size-4 shrink-0" aria-hidden="true" />
      </div>

      <div className="flex flex-1 flex-col bg-white">
        <div className="px-3 py-2.5 text-sm text-gray-700">
          <p className="font-semibold">
            Unlock {EXTEND_WITH_PRODUCT_LABEL[type]}.
          </p>
          <p>{EXTEND_WITH_UPSELL_DESCRIPTION[type]}</p>
        </div>

        <div className="mt-auto px-3 pt-2 pb-3">
          <Button
            variant="brand-filled"
            size="sm"
            className="w-full"
            onClick={handleContactClick}
            data-testid={contactTestId}
          >
            Contact Us
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExtensionUpsellTile;
